import { render, staticRenderFns } from "./WalletDrawer.vue?vue&type=template&id=15b9282a&scoped=true"
import script from "./WalletDrawer.vue?vue&type=script&lang=js"
export * from "./WalletDrawer.vue?vue&type=script&lang=js"
import style0 from "./WalletDrawer.vue?vue&type=style&index=0&id=15b9282a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b9282a",
  null
  
)

export default component.exports